
  export default {
    props: {
      helpStatus: {
        type: Boolean,
        default: false
      },
      helpInitial: {
        type: String
      },
      helpInitialButton: {
        type: String
      },
      helpId: {
        type: String
      },
      collapseNumber: {
        type: Number
      },
      helpTitle: {
        type: String
      },
      helpAnswer: {
        type: String,
        default: ''
      }
    },
    methods:{
      getHtmlEncode(data) {
      return data.replace(/\n/g, '<br/>')
    },
    }
  }

